import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/ItemRender/ModelRenderer.tsx";
import "core-js/modules/es.function.name.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import { Home as HomeIcon } from '@gmini/ui-kit';
import { useHover } from '@gmini/utils';
import { useModelProps } from "../itemPropsCtx";
import { VersionButton } from "../VersionButton/VersionButton";
import { ItemTooltip } from "../../ItemTooltip";
import { AddDepButton } from "../AddDepButton";
import { useExplorerItemStyles } from "../../../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ModelRenderer = /*#__PURE__*/React.memo(function (props) {
  var node = props.item.payload,
      onSelect = props.onSelect,
      selected = props.selected,
      getRef = props.getRef;
  var itemListStyles = useExplorerItemStyles();

  var _useHover = useHover(),
      hover = _useHover.hover,
      onMouseOver = _useHover.onMouseOver,
      onMouseLeave = _useHover.onMouseLeave;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      loading = _React$useState2[0];

  var _useModelProps = useModelProps(node),
      currentEntityData = _useModelProps.currentEntityData,
      included = _useModelProps.included,
      isAdded = _useModelProps.isAdded,
      seoEventHandler = _useModelProps.seoEventHandler;

  if (!currentEntityData) {
    return null;
  }

  return /*#__PURE__*/_jsxs(ListItem, {
    ref: getRef(),
    button: true,
    selected: selected,
    onClick: function onClick() {
      return onSelect();
    },
    dense: true,
    ContainerProps: {
      onMouseOver: onMouseOver,
      onMouseLeave: onMouseLeave
    },
    classes: itemListStyles,
    children: [/*#__PURE__*/_jsx(ListItemIcon, {
      children: /*#__PURE__*/_jsx(HomeIcon, {})
    }), /*#__PURE__*/_jsx(ListItemText, {
      disableTypography: true,
      children: /*#__PURE__*/_jsx(ItemTooltip, {
        title: node.name,
        children: /*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          variant: "body2",
          children: isAdded ? /*#__PURE__*/_jsx("strong", {
            children: node.name
          }) : node.name
        })
      })
    }), /*#__PURE__*/_jsx(ListItemSecondaryAction, {
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: hover ? /*#__PURE__*/_jsx(_Fragment, {
          children: loading ? /*#__PURE__*/_jsx(IconButton, {
            size: "small",
            disabled: true,
            children: /*#__PURE__*/_jsx(CircularProgress, {
              size: 24
            })
          }) : /*#__PURE__*/_jsx(AddDepButton, {
            bimFile: node,
            currentEntity: currentEntityData,
            elementsIncluded: included,
            isAdded: isAdded,
            onBeforeClick: onSelect,
            dataTestId: isAdded ? 'RemoveFromDependency' : 'addToDependency',
            seoEventHandler: seoEventHandler
          })
        }) : /*#__PURE__*/_jsx(VersionButton, {
          versionName: node.versionName,
          author: node.author,
          status: node.status,
          uploadDate: node.uploadDate
        })
      })
    })]
  });
});
ModelRenderer.displayName = 'ModelRenderer';